import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import QrScanner from "./QrScanner";

// Trang đích khi quét QR (Zalo/camera điện thoại mở URL này):
//   https://noibo.bhsgroup.vn/checkin-cho-ngoi?token=xxx
// Nếu có ?token= và đã đăng nhập -> tự động check-in.
// Nếu mở trực tiếp (không token) -> cho quét QR bằng camera trong app.
export default function CheckinQR() {
    const { user } = useSelector((state) => state.auth);
    const location = useLocation();
    const [result, setResult] = useState(null);   // {status, message, data}
    const [processing, setProcessing] = useState(false);
    const [scanning, setScanning] = useState(false);

    const doCheckin = (token) => {
        if (!token) return;
        setProcessing(true);
        Axios.post(URL_LIST_ALL + 'seat_checkin', { qr_token: token }, user.config).then(res => {
            setProcessing(false);
            setResult({ status: res.data.status, message: res.data.message, data: res.data.data });
        }).catch(() => {
            setProcessing(false);
            setResult({ status: 'error', message: 'Lỗi kết nối, vui lòng thử lại' });
        });
    };

    // Tự động check-in nếu URL có ?token=
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        if (token) doCheckin(token);
        else setScanning(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AkkhorLayout idrole="dat-cho-ngoi">
            <div className="breadcrumbs-area">
                <ul>
                    <li><Link to="/">Trang chủ</Link></li>
                    <li>Kích hoạt chỗ ngồi</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body text-center">
                    <h3 className="mb-3">Kích hoạt chỗ ngồi (check-in)</h3>

                    {processing && <p>Đang kích hoạt...</p>}

                    {scanning && !result && (
                        <>
                            <QrScanner readerId="checkin-reader" onScan={doCheckin} onError={(m) => setResult({ status: 'error', message: m })} />
                            <small className="text-muted d-block mt-2">Hướng camera vào mã QR dán tại chỗ ngồi.</small>
                        </>
                    )}

                    {result && (
                        <div className={"alert mt-3 " + (result.status === 'success' ? 'alert-success' : 'alert-danger')}>
                            <strong>{result.status === 'success' ? 'Thành công!' : 'Không kích hoạt được'}</strong>
                            <div>{result.message}</div>
                            {result.status === 'success' && result.data && result.data.end_time && (
                                <div className="mt-1">Sử dụng đến: {result.data.end_time}</div>
                            )}
                            <Link to="/dat-cho-ngoi" className="btn btn-sm btn-primary mt-2">Về trang đặt chỗ</Link>
                        </div>
                    )}
                </div>
            </div>
        </AkkhorLayout>
    );
}
